import React, { useMemo, useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { Box, Grid, IconButton } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';

import { useTranslation } from "react-i18next";
import DataTable from "../common/DataTable";
import { genericGet } from "../../services/apiServices";
import { GET_CUSTOMER_PRODUCT } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import CustomLoader from "../common/CustomLoader";
import CustomReport from "../common/CustomReport";
import CustomAutocomplete from "../common/CustomAutoComplete";
import CustomButton from "../common/CustomButton";
import CustomFilter from "../common/CustomFilter";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { ClearRounded, } from "@mui/icons-material";
import { getCustumersList } from "../../services/CommonServices";
import { genericPost } from "../../services/authServices";
import CustomDataTable from "../common/CustomDataTable";
import { AccessDenied, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from "../../services/CommonServices";
import { useLocation } from "react-router-dom";
import CustomTextField from "../common/CustomTextField";



const title = "Customer wise Product";

const CustomerProduct = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext)
    const [permission, setPermissions] = useState()
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [totalGrandQty, setTotalGrandQty] = useState(0);
    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [custumersList, setCustumersList] = useState([]);
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [filterPayload, setFilterPayload] = useState({
        clientCompanyId: '',
        fromDate: '',
        toDate: '',
    });
    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        let createPermision = hasCreatePermission(currentPath, rolePermisionsData?.permissions)
        let viewPermision = hasViewPermission(currentPath, rolePermisionsData?.permissions)

        setPermissions({
            edit: editPermision,
            delete: deletePermission,
            create: createPermision,
            view: viewPermision,
        })
    }, [])
    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };
    const handleClearFilters = useMemo(() => {
        return () => {
            setFilterPayload({
                clientCompanyId: '',
                fromDate: '',
                toDate: '',
            });
            fetchData(0, pageSize, '');
        };
    }, [pageSize]);
    useEffect(() => {
        getCommonData();
    }, []);
    const getCommonData = async () => {
        const custumersList = await getCustumersList();
        setCustumersList(custumersList);
    }

    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            {
                accessorKey: 'clientCompanyName', header: 'Customer Name', size: 150, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: 'billingCountry', header: 'Country', size: 100, tableHeader: {
                    justifyContent: 'flex-start',
                },
                footer: 'Total',
            },

            { accessorKey: 'totalQty', header: 'total Qty', size: 50, tableStyle: { textAlign: "center" }, footerCellStyle: { textAlign: "center" }, footer: totalGrandQty.toFixed(2), },
            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                        <IconButton onClick={() => handleViewClick(row.original.clientCompanyId)}>
                            <VisibilityIcon />
                        </IconButton>
                    </div>
                ),
            },
        ],
        [totalGrandQty, permission]
    );
    const handleViewClick = (clientCompanyId) => {
        navigate(`/app/reports/customerproductmonthly/${clientCompanyId}`);
    };

    const fetchData = async (pageIndex = 0, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageSize,
                ...filterPayload
            };
            const response = await genericPost(GET_CUSTOMER_PRODUCT, payload, {});
            if (response.data.success && Array.isArray(response.data.commercialInvExps)) {
                const invoiceData = [];
                let indexCounter = 1;
                let grandQty = 0; // 🟡 Initialize grand total


                response.data.commercialInvExps.forEach(exp => {
                    const currency = {
                        name: exp.currency?.currency_name || '',
                        symbol: exp.currency?.currency_symbol || ''
                    };

                    const totalAmount = parseFloat(exp.totalAmount || 0);
                    const paymentAmount = parseFloat(exp.totalReceiptAmount || 0);
                    const balanceAmount = (totalAmount - paymentAmount).toFixed(2);

                    const totalQty = parseFloat(exp.totalQty || 0);
                    grandQty += totalQty;

                    invoiceData.push({
                        index: indexCounter.toString().padStart(2, '0'),
                        clientCompanyId: exp.clientCompanyId || '',
                        clientCompanyName: exp.clientCompanyName || '',
                        billingCountry: exp.billingCountry?.name || '',
                        currencyId: exp.currency?.id || '',
                        contactPerson: `${exp.companyAdmin?.firstName || ''} ${exp.companyAdmin?.lastName || ''}`.trim(),
                        // currency,
                        currency: `${currency.name} (${currency.symbol})`,

                        particulars: exp.particulars?.map(p => ({
                            particularsId: p.commercialInvoiceParticularsID || '',
                            productName: p.particularName || '',
                            qty: p.qty || '',
                            rate: p.rate || '',
                            unit: p.unit || '',
                            amount: p.amount || '',
                            description: p.description || '',
                        })) || [],
                        receiptVoucherNo: exp.paymentVouchers?.map(pv => pv.paymentVoucherNo).join(', ') || '',
                        totalAmount: `${currency.symbol} ${totalAmount.toFixed(2)}`,
                        paymentAmount: `${currency.symbol} ${paymentAmount.toFixed(2)}`,
                        balanceAmount: `${currency.symbol} ${balanceAmount}`,
                        totalQty: exp.totalQty || '',
                    });

                    indexCounter++;
                });

                setData(invoiceData);
                setTotalGrandQty(grandQty);
                setRowCount(response.data.pagination?.totalRecords || 0);

            } else {
                setError("No supplier ledger data found");
            }
        } catch (error) {
            setError("Error fetching supplier ledger");
            console.error("Error fetching supplier ledger", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(page, pageSize)
    }, [page, pageSize, token])

    const defaultView = 'customerproduct';
    const mainContent = (
        <>
            <CustomLoader open={loading} />
            <CustomDataTable
                title={title}
                columns={columns}
                data={data}
                openDrawer={openDrawer}
                onClose={filterClose}
                handleFilterButton={filterOpen}
                fiterButtonTitile="Fiter"
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                fromDate={filterPayload.fromDate || ""}
                toDate={filterPayload.toDate || ""}
            />
            <CustomFilter
                drawerTitle="Filter Options"
                drawerWidth={300}
                openDrawer={openDrawer}
                onClose={filterClose}
                drawerContent={
                    <>
                        <Box>
                            <Grid container spacing={1} sx={{ padding: 0, }}>

                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomAutocomplete
                                        options={custumersList}
                                        getOptionLabel={(option) => option.title}
                                        placeholder="Select Customer"
                                        value={custumersList.find((item) => item.id === filterPayload.clientCompanyId) || null}
                                        onChange={(event, newValue) => handleFilterChange("clientCompanyId", newValue?.id)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="from Date"
                                        type="date"
                                        value={filterPayload.fromDate}
                                        onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                        placeholder="From Date"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="to Date"
                                        type="date"
                                        value={filterPayload.toDate}
                                        onChange={(e) => handleFilterChange('toDate', e.target.value)}
                                        placeholder="To Date"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                                    <CustomButton
                                        startIcon={<FindReplaceOutlinedIcon />}
                                        title="Apply"
                                        size="small"
                                        variant="contained"
                                        onClick={fetchData}
                                    />
                                    <CustomButton
                                        variant="outlined"
                                        title="Clear"
                                        startIcon={<ClearRounded />}
                                        onClick={handleClearFilters}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                }
            />
        </>
    );

    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };


    return (
        <>
            <CustomReport
                defaultView={defaultView}
                mainContent={getMainContent(mainContent, permission)} />
            {!permission?.view && <AccessDenied />}


        </>
    );
};
export default CustomerProduct;
